/* Dismisses the collection PLP skeleton when Boost has rendered into the grid.
 * Filter/ProductList afterRender hooks are unreliable on collection pages; we watch the DOM. */
(function () {
  var DISMISSED = 'data-boost-pfs-skeleton-dismissed'

  function hide(skeleton) {
    if (!skeleton || skeleton.getAttribute(DISMISSED) === 'true') return
    skeleton.setAttribute(DISMISSED, 'true')
    skeleton.hidden = true
    skeleton.classList.add('boost-pfs-collection-skeleton--hidden')
    skeleton.style.display = 'none'
    skeleton.setAttribute('aria-busy', 'false')
  }

  function boostHasPainted(grid) {
    if (!grid) return false
    if (grid.querySelector('.collection__item--bc')) return true
    if (grid.querySelector('.boost-pfs-filter-message')) return true
    return false
  }

  function init() {
    var skeleton = document.querySelector('[data-boost-pfs-collection-skeleton]')
    var grid = document.querySelector('[data-collection-item-container]')
    if (!skeleton || !grid) return

    if (boostHasPainted(grid)) {
      hide(skeleton)
      return
    }

    var mo = new MutationObserver(function () {
      if (boostHasPainted(grid)) {
        hide(skeleton)
        mo.disconnect()
      }
    })
    mo.observe(grid, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    })

    window.addEventListener('load', function onLoad() {
      window.removeEventListener('load', onLoad)
      if (boostHasPainted(grid)) hide(skeleton)
    })

    setTimeout(function () {
      mo.disconnect()
    }, 60000)
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init)
  } else {
    init()
  }
})()
